import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { User, LogOut, LayoutDashboard, Menu } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-white/20" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="text-2xl font-display font-bold text-primary" data-testid="logo-link">
            Hotel Del Rio
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/rooms" className="text-text-primary hover:text-primary transition-colors" data-testid="rooms-link">
              Quartos
            </Link>
            <Link to="/contact" className="text-text-primary hover:text-primary transition-colors" data-testid="contact-link">
              Contato
            </Link>
            <Link to="/policies" className="text-text-primary hover:text-primary transition-colors" data-testid="policies-link">
              Políticas
            </Link>

            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="sm" data-testid="user-menu-trigger">
                    <User className="h-4 w-4 mr-2" />
                    {user.name}
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  {isAdmin ? (
                    <DropdownMenuItem asChild data-testid="admin-dashboard-link">
                      <Link to="/admin" className="w-full flex items-center">
                        <LayoutDashboard className="h-4 w-4 mr-2" />
                        Admin Dashboard
                      </Link>
                    </DropdownMenuItem>
                  ) : (
                    <DropdownMenuItem asChild data-testid="my-bookings-link">
                      <Link to="/my-bookings" className="w-full flex items-center">
                        <LayoutDashboard className="h-4 w-4 mr-2" />
                        Minhas Reservas
                      </Link>
                    </DropdownMenuItem>
                  )}
                  <DropdownMenuItem onClick={logout} data-testid="logout-button">
                    <LogOut className="h-4 w-4 mr-2" />
                    Sair
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Link to="/login" data-testid="login-link">
                <Button size="sm">Login</Button>
              </Link>
            )}
          </div>

          <button
            className="md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-button"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden py-4 space-y-3" data-testid="mobile-menu">
            <Link to="/rooms" className="block text-text-primary hover:text-primary" onClick={() => setMobileOpen(false)}>
              Quartos
            </Link>
            <Link to="/contact" className="block text-text-primary hover:text-primary" onClick={() => setMobileOpen(false)}>
              Contato
            </Link>
            <Link to="/policies" className="block text-text-primary hover:text-primary" onClick={() => setMobileOpen(false)}>
              Políticas
            </Link>
            {user ? (
              <>
                {isAdmin ? (
                  <Link to="/admin" className="block text-text-primary hover:text-primary" onClick={() => setMobileOpen(false)}>
                    Admin Dashboard
                  </Link>
                ) : (
                  <Link to="/my-bookings" className="block text-text-primary hover:text-primary" onClick={() => setMobileOpen(false)}>
                    Minhas Reservas
                  </Link>
                )}
                <button onClick={() => { logout(); setMobileOpen(false); }} className="block text-text-primary hover:text-primary">
                  Sair
                </button>
              </>
            ) : (
              <Link to="/login" onClick={() => setMobileOpen(false)}>
                <Button size="sm" className="w-full">Login</Button>
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};
